<template lang="pug">
  div
    div(style="height: 100px") // этот div не нужен


    div.waybill-item

      div.waybill-item-block
        div.waybill-item-block__title
          div.number 1
          div Контейнерная площадка №44243

        div.waybill-item-block__text
          div.waybill-item-block__text-item
            div.title Местоположение:
            div.value ул. Мира 23
          div.waybill-item-block__text-item
            div.title Дата обслуживания:
            div.value 24.03.18 14:45
          div.waybill-item-block__text-item
            div.title Убрано:
            div.value 3 контейнера
          div.waybill-item-block__text-item
            div.title Объем:
            div.value 3,25 куб.м

        div.waybill-item-block__photos
          div.left
            img()
            .caption До обслуживания
          div.right
            img()
            .caption После обслуживания

      div.waybill-item-block
        div.waybill-item-block__title
          div.number 1
          div Контейнерная площадка №44243

        div.waybill-item-block__text
          div.waybill-item-block__text-item
            div.title Местоположение:
            div.value ул. Мира 23
          div.waybill-item-block__text-item
            div.title Дата обслуживания:
            div.value 24.03.18 14:45
          div.waybill-item-block__text-item
            div.title Убрано:
            div.value 3 контейнера
          div.waybill-item-block__text-item
            div.title Объем:
            div.value 3,25 куб.м

        div.waybill-item-block__photos
          div.left
            img()
            .caption До обслуживания
          div.right
            img()
            .caption После обслуживания

      div.waybill-item-block
        div.waybill-item-block__title
          div.number 1
          div Контейнерная площадка №44243

        div.waybill-item-block__text
          div.waybill-item-block__text-item
            div.title Местоположение:
            div.value ул. Мира 23
          div.waybill-item-block__text-item
            div.title Дата обслуживания:
            div.value 24.03.18 14:45
          div.waybill-item-block__text-item
            div.title Убрано:
            div.value 3 контейнера
          div.waybill-item-block__text-item
            div.title Объем:
            div.value 3,25 куб.м

        div.waybill-item-block__photos
          div.left
            img()
            .caption До обслуживания
          div.right
            img()
            .caption После обслуживания

      div.waybill-item-block
        div.waybill-item-block__title
          div.number 1
          div Контейнерная площадка №44243

        div.waybill-item-block__text
          div.waybill-item-block__text-item
            div.title Местоположение:
            div.value ул. Мира 23
          div.waybill-item-block__text-item
            div.title Дата обслуживания:
            div.value 24.03.18 14:45
          div.waybill-item-block__text-item
            div.title Убрано:
            div.value 3 контейнера
          div.waybill-item-block__text-item
            div.title Объем:
            div.value 3,25 куб.м

        div.waybill-item-block__photos
          div.left
            img()
            .caption До обслуживания
          div.right
            img()
            .caption После обслуживания

</template>

<script>
  export default {};

</script>

